<template lang="pug">
.event-search
  .event-search-con.layout_screen_width
    .router-view
      router-view
    //- recently-hot-case
</template>
<script>
import RecentlyHotCase from './RecentlyHotCase'
export default {
  name: 'EventSearch',
  data () {
    return {}
  },
  computed: {
    params () {
      return this.$store.getters.searchParams
    }
  },
  mounted () { },
  methods: {},
  components: {
    RecentlyHotCase
  }
}
</script>
<style lang="scss" scoped>
.event-search {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  // background-color: #e8ebf1;
  .event-search-con {
    width: 100%;
    height: 100%;
    display: flex;
    // padding: 24px 0;
  }
  .router-view {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/EventSearch.vue